import {fabric} from 'fabric';
import {silver, cloud} from '~libSass/base/_exports.sass';

export function renderIcon({icon, fillStyle = silver, strokeStyle = cloud, padding = 2}) {
  const img = document.createElement('img');
  img.src = icon;
  return function _renderIcon(ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;

    ctx.save();
    ctx.beginPath();
    ctx.arc(left, top, size / 2 + padding, 0, 2 * Math.PI, false);
    ctx.fillStyle = fillStyle;
    ctx.fill();
    ctx.strokeStyle = strokeStyle;
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.restore();

    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(img, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}
